module.exports = __webpack_public_path__ + "static/media/venmo.64900e25.png";